import type { IIndicatorFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/IndicatorFieldsFragment.generated";
import { invariant } from "outvariant";
import type { IntlShape } from "react-intl";

export default function getIndicatorDocumentation(
  intl: IntlShape,
  indicator: Pick<IIndicatorFieldsFragment, "objectId" | "documentation">,
) {
  invariant(indicator.documentation.length > 0, `Indicator "%s" has no documentation`, indicator.objectId);
  const localeLanguageCode = intl.locale === "pt-BR" || intl.locale === "pt" ? "pt" : "en";
  const documentation =
    indicator.documentation.find(({ languageCode }) => languageCode === localeLanguageCode) ||
    indicator.documentation[0];
  return documentation;
}
